/**
 * 결혼식 카운트다운 표준 컨트롤러.
 *
 * [data-fw-countdown] 컨테이너의 data-target 속성에서 목표 일시를 읽어
 * 매초 남은 시간 업데이트. 지난 경우 "결혼식으로부터 N일" 모드로 전환.
 *
 * DOM 규약:
 *   <div data-fw-countdown data-target="{{ wedding.date }}">
 *     <span data-fw-countdown-label>결혼식까지</span>
 *     <span data-fw-countdown-days>0</span>일
 *     <span data-fw-countdown-hours>0</span>시간
 *     <span data-fw-countdown-minutes>0</span>분
 *     <span data-fw-countdown-seconds>0</span>초
 *   </div>
 *
 * id 폴백: #ceremonyCountdown(data-timestamp 포함) + #cdLabel/#cdDays/#cdHours/#cdMinutes/#cdSeconds.
 * data-target 값은 ISO string (2027-06-15T14:00:00+09:00), "YYYY-MM-DD HH:mm",
 * 혹은 밀리초 timestamp 모두 허용 — `Date.parse` 가 파싱 못 하면 컨트롤러는 silent skip.
 */
export const COUNTDOWN_CONTROLLER_SCRIPT = `
<script data-fw-countdown-controller>
(function () {
  var root = document.querySelector('[data-fw-countdown]') || document.getElementById('ceremonyCountdown');
  if (!root) return;
  var raw = root.getAttribute('data-target') || root.getAttribute('data-timestamp');
  if (!raw) return;
  var target = /^\\d+$/.test(raw) ? Number(raw) : Date.parse(raw);
  if (isNaN(target)) return;

  function pick(sel, fallbackId) {
    return root.querySelector(sel) || document.getElementById(fallbackId);
  }
  var elLabel = pick('[data-fw-countdown-label]', 'cdLabel');
  var elDays = pick('[data-fw-countdown-days]', 'cdDays');
  var elHours = pick('[data-fw-countdown-hours]', 'cdHours');
  var elMinutes = pick('[data-fw-countdown-minutes]', 'cdMinutes');
  var elSeconds = pick('[data-fw-countdown-seconds]', 'cdSeconds');

  function setText(el, v) { if (el) el.textContent = String(v); }

  function update() {
    var diff = target - Date.now();
    var elapsed = Math.abs(diff);
    if (diff <= 0 && elLabel) elLabel.textContent = '결혼식으로부터';
    else if (elLabel) elLabel.textContent = '결혼식까지';
    var d = Math.floor(elapsed / 86400000);
    var h = Math.floor((elapsed % 86400000) / 3600000);
    var m = Math.floor((elapsed % 3600000) / 60000);
    var s = Math.floor((elapsed % 60000) / 1000);
    setText(elDays, d);
    setText(elHours, h);
    setText(elMinutes, m);
    setText(elSeconds, s);
  }
  update();
  setInterval(update, 1000);
})();
</script>
`;
//# sourceMappingURL=countdown.js.map